module.exports = "<div>\n    <h2>Not Found</h2>\n    <p>We're sorry, but that page/resource doesn't exist.</p>\n</div>";